import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<se-po-persona-avatar
  [persona]="persona">
  <se-fe-button
    personaAvatarActions
    (click)="onEdit()"
    seFeDataEmphasis="low">
    Edit
  </se-fe-button>
</se-po-persona-avatar>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'
export class PersonaAvatarActionExampleComponent implements OnInit {
  public persona: Persona
  public ngOnInit(): void {
    this.persona = {
      id: 9,
      date_of_birth: '2009-12-31',
      first_name:'Someone',
      gender: 'female',
      last_name: 'Test'
    } as Persona
  }

}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-avatar-action-example',
  template,
  styleUrls: ['./../persona-avatar-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarActionExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona

  public ngOnInit(): void {
    this.persona = {
      id: 9,
      date_of_birth: '2009-12-31',
      first_name:'Someone',
      gender: 'female',
      last_name: 'Test'
    } as Persona
  }

  public onEdit(): void {
    console.log('onEdit', this.persona)
  }
}
